import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query'
import type { Paged, ProblemCard } from '@/shared/lib/apiTypes'
import { countsById } from '@/shared/lib/cardCounts'
import { useSearchParams } from 'react-router-dom'
import { useListFilter } from '@/shared/composables/useListFilter'

export function useProblemListFilter(
  query: UseInfiniteQueryResult<InfiniteData<Paged<ProblemCard>>>,
) {
  const all = query.data?.pages.flatMap((page) => page.items) ?? []

  const [params] = useSearchParams()
  const groupFromUrl = params.get('group')
  const regionFromUrl = params.get('region')

  const base = useListFilter(
    all,
    {
      categories: (p) => p.categoryCodes ?? [],
      targets: (p) => p.targetCodes,
      regions: (p) => [p.region.code],
    },
    groupFromUrl,
    regionFromUrl === null ? [] : [regionFromUrl],
  )

  const counts = countsById(all, (p) => p.matchedSolutionCount)

  return { ...base, items: base.filtered, all, counts }
}
